import { defineMessages } from "react-intl";

import { useFormatMessage } from "../../../Intl/Context";
import Button from "../../../Buttons/Button";

const ContributionsDatavizGraphThemePagination = props => {
  const {
    nextPage,
    previousPage,
    hasNextPage,
    hasPreviousPage,
    startIndex,
    endIndex,
    totalResultsCount
  } = props.resultsLoader || {};

  const t = useFormatMessage();
  const paginationLabel = t(intlMessages.pagination, {
    startIndex: startIndex + 1,
    endIndex,
    totalResultsCount
  });

  return (
    <div className="d-inline-flex align-items-center">
      <Button
        className="btn-unstyled margin-right-xs"
        iconClassName="fa fa-chevron-left"
        onClick={previousPage}
        disabled={!hasPreviousPage}
      />

      <div className="flex-1">{paginationLabel}</div>

      <Button
        className="btn-unstyled margin-left-xs"
        iconClassName="fa fa-chevron-right"
        onClick={nextPage}
        disabled={!hasNextPage}
      />
    </div>
  );
};

export default ContributionsDatavizGraphThemePagination;

const intlMessages = defineMessages({
  pagination: {
    id: "contributions.dataviz.pagination",
    defaultMessage: "Contributions {startIndex} à {endIndex} sur {totalResultsCount}"
  }
});
